export default __webpack_public_path__ + "locales/fr.bb0a81169ed5d1dc7370945fd2779620.json";